import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/search-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/Share.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
